import { Component, Input } from '@angular/core'

export enum LogoTheme {
  White = 'white',
  Colored = 'color',
}

export enum LogoSize {
  /**
   * Full width on medium-up, wave form only on mobile
   */
  Default = 'default',
  /**
   * Always full-width
   */
  FullWidth = 'full-width',
  /**
   * Always wave form only
   */
  WaveOnly = 'wave-only',
}

@Component({
  selector: 'ftr-logo',
  templateUrl: './ftr-logo.component.html',
  styleUrls: ['./ftr-logo.component.css'],
})
export class FtrLogoComponent {
  @Input() size: LogoSize = LogoSize.Default
  @Input() theme: LogoTheme = LogoTheme.Colored
  themes = LogoTheme
  sizes = LogoSize
}
